import ApiService from '@/services/ApiService';
import {
  IIncentive,
  IIncentiveRankingData,
  IIncentiveRanking,
  IIncentivesData,
  ISearchResults,
  IVotePartner,
} from '@/common/interfaces/single-incentive.interface';
import ApplicationError from '@/errors/application-error';
import { ICustomerSession } from '@/common/interfaces/customers.interface';

export default class SingleIncentiveService {
  private apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
  }

  public async getIncentiveById(incentiveID: number): Promise<IIncentive> {
    const incentives = await this.apiService.getIncentives();
    const incentive = incentives.find(el => el.id === incentiveID);

    if(!incentive) {
      throw new ApplicationError(`No incentive found`);
    }

    return incentive;
  }

  public async getIncentiveRanking(incentiveID: number, limit: number): Promise<IIncentiveRanking> {
    return this.apiService.getIncentiveRanking({
      data: { limit },
      params: { id: incentiveID },
    });
  }

  public async getIncentiveClimberRanking(incentiveID: number, limit: number): Promise<IIncentiveRanking> {
    return this.apiService.getIncentiveClimberRanking({
      data: { limit },
      params: { id: incentiveID },
    });
  }

  public async getMyStatusData(incentiveID: number, customerID: number): Promise<IIncentiveRankingData | undefined> {
    const response = await this.apiService.getIncentiveRanking({
      data: { limit: 5000 },
      params: { id: incentiveID },
    });

    return response.ranking ? response.ranking.find(el => el.customerNumber === customerID) : undefined;
  }

  public async getIncentiveData(incentiveID: number): Promise<IIncentivesData> {
    return this.apiService.getIncentiveData({ params: { id: incentiveID } });
  }

  public async getSearchResults(incentiveID: number, searchValue: string): Promise<ISearchResults[]> {
    return this.apiService.getSearchResults({ params: { id: incentiveID, search: searchValue } });
  }

  public async votePartner(incentiveID: number, customerNumber: number): Promise<IVotePartner> {
    return this.apiService.votePartner({ params: { cn: customerNumber, id: incentiveID } });
  }

  public async getCustomerSession(): Promise<ICustomerSession> {
    return this.apiService.getCustomerSession();
  }
}
